const decimalHelper = require('./decimalHelper');

/**
 * 상품 가격 계산 (상품할인 행사 포함)
 *
 * @param {*} baskets : 장바구니 상품 정보
 * @param {*} posConfig : Pos Config
 * @returns
 */
exports.calculate = async (baskets, posConfig) => {
  baskets.HEADER = {
    // 총 판매 금액 (각 상품별 SALES_UPRC * SALES_QTY 의 합)
    TOT_SALES_AMT: 0,
    // 총 할인 금액 ( 각 상품별 DC_AMT의 합)
    TOT_DC_AMT: 0,
    // 판매 수량 (각 상품 수량 합)
    SALES_QTY: 0,
    // 주문 수량 (SALES_QTY - 옵션 상품 수량)
    ORDER_QTY: 0,
    // 판매 금액 (각 상품별 SALES_AMT의 합)
    SALES_AMT: 0,
    // 부가세 (각 상품별 부가세의 합)
    VAT_AMT: 0,
    // 봉사료 (각 상품별 봉사료의 합)
    SVC_AMT: 0,
    // 지불한 금액 (쿠폰으로 지불한 금액의 합)
    PAID_AMT: 0,
    // 판매금액 ORIGIN
    ORG_SALES_AMT: 0,
    // 총 할인 금액 ORIGIN
    ORG_TOT_DC_AMT: 0,
    // 부가세 ORIGIN
    ORG_VAT_AMT: 0,
  };

  // console.log(`calculate begin: ${JSON.stringify({baskets})}\n`);

  // 상품별 계산
  for (let i = 0; i < baskets.ITEMLIST.length; i++) {
    let item = baskets.ITEMLIST[i];
    calcItem(false, item, baskets, posConfig);

    // 옵션 상품별 계산
    for (let j = 0; j < item.OPTIONITEM.length; j++) {
      let optionItem = item.OPTIONITEM[j];
      calcItem(true, optionItem, baskets, posConfig);
    }
  }

  // 멤버쉽 정보 취소 시, ORIGIN 정보 보관용
  baskets.HEADER.ORG_SALES_AMT = baskets.HEADER.SALES_AMT;
  baskets.HEADER.ORG_TOT_DC_AMT = baskets.HEADER.TOT_DC_AMT;
  baskets.HEADER.ORG_VAT_AMT = baskets.HEADER.VAT_AMT;
  //console.log(`calculate end: ${JSON.stringify({baskets})}\n`);
  //return JSON.stringify({baskets});
};

// 상품(옵션 포함) 별 가격 계산
function calcItem(isOption, item, baskets, posConfig) {
  // 부가세 단가
  let VAT_UPRC = 0;
  const decimalPlace = Number(posConfig.decimalPlace); // 소수점 자리수
  const amountRoundType = posConfig.amountRoundType.toLowerCase(); // 금액 계산 방식 (반올림-round/절상-ceil/절하-floor)
  const isTaxIncluded = posConfig.isTaxIncluded; // 세금 판매가 포함 여부
  const saleUnit = Number(posConfig.saleUnit); // 판매단위

  const discountAmountRoundType = posConfig.discountRoundType.toLowerCase(); //할인 금액 계산 방식 (반올림-round/절상-ceil/절하-floor)
  const discountSaleUnit = Number(posConfig.discountSaleUnit); // 할인 판매단위

  // 행사 적용 상품일 시 할인 금액 적용
  if (item.DC_ABLE_YN === 'Y' && item.EVENTITEM.length !== 0 && item.EVENTITEM[0].EVNT_ITEM_CD != '' && item.EVENTITEM[0].EVNT_ITEM_CD != null) {
    const date = new Date();
    let now = date.getHours() + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());

    // 타임세일이 적용되어 있지 않은 경우 or 타임세일 적용 시 시간 안에서만 할인 적용
    if (
      item.EVENTITEM[0].TIME_SALE_YN != 'Y' ||
      (item.EVENTITEM[0].TIME_SALE_YN === 'Y' && item.EVENTITEM[0].TIME_SALE_FROM_TIME <= now && now <= item.EVENTITEM[0].TIME_SALE_END_TIME)
    ) {
      // 상품할인 금액 행사
      if (item.EVENTITEM[0].EVNT_FLG_CD === '03') {
        let evntDcAmt = item.EVENTITEM[0].DC_AMT;

        // 금액 할인
        if (item.EVENTITEM[0].DC_FLG_CD == 1) {
          // % 할인
        } else if (item.EVENTITEM[0].DC_FLG_CD == 2) {
          evntDcAmt = item.ORG_SALES_UPRC * (item.EVENTITEM[0].DC_AMT / 100); // 할인율 적용 금액 산정
        }
        // 할인 금액을 판매단위에 맞게 보정
        if (discountAmountRoundType == 'round') {
          evntDcAmt = decimalHelper.roundInt(evntDcAmt, discountSaleUnit - 1);
        } else if (discountAmountRoundType == 'floor') {
          evntDcAmt = decimalHelper.floorInt(evntDcAmt, discountSaleUnit - 1);
        } else {
          evntDcAmt = decimalHelper.ceilInt(evntDcAmt, discountSaleUnit - 1);
        }

        // 할인 금액
        item.DC_AMT = Number(evntDcAmt); // 할인 금액
      }
    }
  }

  // 부가세 계산: 면세(0) 과세(1) 영세(2)
  if (item.TAX_FLG_CD === '1') {
    // 경감세율 적용 상품이고, 포장하기인 경우 경감세율 적용
    if (item.TAX_RDC_FLG_CD === '01' && baskets.EXTRA.ORDER_TYPE == '2') {
      item.VAT_RATE = posConfig.reducedTaxRate;
      item.RDC_TAX_APPLIED = 'Y';
    }
    // 아니면 일반 부가세율 적용
    else {
      item.VAT_RATE = posConfig.taxRate;
      item.RDC_TAX_APPLIED = 'N';
    }

    // 판매 단위를 기준으로 분류
    // 1단위
    item.SALES_UPRC = item.ORG_SALES_UPRC - item.DC_AMT; // 할인 적용된 금액
    if (saleUnit === 1) {
      // 부가세 계산
      VAT_UPRC = item.SALES_UPRC / (100 / item.VAT_RATE + (isTaxIncluded ? 1 : 0));

      // 소수점 자리수 확인 하여 계산
      // 0 : 소수점 1단위에서 처리, 1 : 소수점 2단위에서 처리, 3 : 소수점 3 단위에서 처리
      if (amountRoundType === 'ceil') {
        VAT_UPRC = decimalHelper.ceil(VAT_UPRC, decimalPlace);
      } else if (amountRoundType === 'floor') {
        VAT_UPRC = decimalHelper.floor(VAT_UPRC, decimalPlace);
      } else {
        VAT_UPRC = decimalHelper.round(VAT_UPRC, decimalPlace);
      }

      // 10단위, 100단위, 1000단위 - 소수점 자리수 필드는 의미 없고, 단위별 금액 계산 방식 적용
    } else {
      // 부가세 계산
      VAT_UPRC = item.SALES_UPRC / (100 / item.VAT_RATE + (isTaxIncluded ? 1 : 0));

      // 세후 일 시 소수점 1자리에서 금액 방식 적용
      if (isTaxIncluded) {
        if (amountRoundType === 'ceil') {
          VAT_UPRC = decimalHelper.ceil(VAT_UPRC, 0);
        } else if (amountRoundType === 'floor') {
          VAT_UPRC = decimalHelper.floor(VAT_UPRC, 0);
        } else {
          VAT_UPRC = decimalHelper.round(VAT_UPRC, 0);
        }
        // 세전 일 시 소수점 삭제하고, 판매 단위별 세금 계산
      } else {
        VAT_UPRC = Math.floor(VAT_UPRC);

        if (amountRoundType === 'ceil') {
          VAT_UPRC = decimalHelper.ceilInt(VAT_UPRC, saleUnit - 1);
        } else if (amountRoundType === 'floor') {
          VAT_UPRC = decimalHelper.floorInt(VAT_UPRC, saleUnit - 1);
        } else {
          VAT_UPRC = decimalHelper.roundInt(VAT_UPRC, saleUnit - 1);
        }
      }
    }

    // 세전 세팅은 SALES_UPRC에 부가세를 더함
    item.SALES_UPRC = isTaxIncluded ? item.SALES_UPRC : item.SALES_UPRC + VAT_UPRC;
    // 부가세 합계 = 부가세 단가 * 수량
    item.VAT_AMT = VAT_UPRC * item.SALES_QTY;
  } else {
    // 면세, 영세의 경우 할인 금액만 적용
    item.VAT_AMT = 0;
    item.VAT_RATE = 0;
    item.SALES_UPRC = item.ORG_SALES_UPRC - item.DC_AMT;
  }

  // 세전 판매 단가
  //let NO_TAX_SALES_UPRC = posConfig.isTaxIncluded ? item.NRML_UPRC - VAT_UPRC : item.NRML_UPRC;
  // 세후 판매 단가
  //item.SALES_UPRC = NO_TAX_SALES_UPRC + VAT_UPRC;
  // 판매 금액 (SALES_UPRC에 할인이 적용된 세후금액으로 계산되어 있음)
  item.SALES_AMT = item.SALES_UPRC * item.SALES_QTY;
  // 봉사료
  item.SVC_AMT = 0;
  // 공급가액
  item.SUPY_AMT = item.SUPY_UPRC * item.SALES_QTY;
  // 행사 금액
  item.DC_AMT = item.DC_AMT * item.SALES_QTY;

  // 총 판매 금액 (할인 적용되지 않은)
  //baskets.HEADER.TOT_SALES_AMT += item.SALES_UPRC * item.SALES_QTY;
  baskets.HEADER.TOT_SALES_AMT += (item.SALES_UPRC - item.DC_AMT) * item.SALES_QTY;
  // 총 할인 금액
  baskets.HEADER.TOT_DC_AMT += item.DC_AMT * item.SALES_QTY;
  // 총 판매 수량
  baskets.HEADER.SALES_QTY += item.SALES_QTY;
  // 총 주문 수량 (옵션 상품 제외)
  if (!isOption) {
    baskets.HEADER.ORDER_QTY += item.SALES_QTY;
  }
  // 총 판매 금액 (할인 적용된)
  baskets.HEADER.SALES_AMT += item.SALES_AMT;
  // 총 봉사료
  baskets.HEADER.SVC_AMT += item.SVC_AMT;
  // 총 부가세액
  baskets.HEADER.VAT_AMT += item.VAT_AMT;

  // console.log(`calcItem: ${JSON.stringify(item)}\n`);
}

/**
 * 영수증 할인 행사 계산
 *
 * @param {*} baskets : 장바구니 상품 정보
 * @param {*} posConfig : Pos Config
 * @param {*} receiptDiscount : 영수증 할인 행사 정보
 * @returns
 */
exports.receipt = async (baskets, posConfig, receiptDiscount) => {
  // 총 판매 금액
  let totSalesAmt = Number(baskets.HEADER.TOT_SALES_AMT);

  // 거래금액 (영수증 할인 행사 조건)
  let stdAmt = Number(receiptDiscount.STD_AMT);

  // 조건이 맞을 시에만 적용 (총 판매금액이 영수증할인 거래금액보다 커야 함)
  if (totSalesAmt < stdAmt) {
    return;
  }

  const date = new Date();
  let now = date.getHours() + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  // 타임세일 적용 시 시간 안에서만 할인 적용
  if (receiptDiscount.TIME_SALE_YN === 'Y' && (receiptDiscount.TIME_SALE_FROM_TIME >= now || now >= receiptDiscount.TIME_SALE_END_TIME)) {
    return;
  }

  baskets.HEADER = {
    // 총 판매 금액 (각 상품별 SALES_UPRC * SALES_QTY 의 합)
    TOT_SALES_AMT: 0,
    // 총 할인 금액 ( 각 상품별 DC_AMT의 합)
    TOT_DC_AMT: 0,
    // 판매 수량 (각 상품 수량 합)
    SALES_QTY: 0,
    // 주문 수량 (SALES_QTY - 옵션 상품 수량)
    ORDER_QTY: 0,
    // 판매 금액 (각 상품별 SALES_AMT의 합)
    SALES_AMT: 0,
    // 부가세 (각 상품별 부가세의 합)
    VAT_AMT: 0,
  };

  // 할인 금액 or %
  let receiptEvntDcAmt = receiptDiscount.DC_AMT;
  const discountAmountRoundType = posConfig.discountRoundType.toLowerCase(); //할인 금액 계산 방식 (반올림-round/절상-ceil/절하-floor)
  const discountSaleUnit = Number(posConfig.discountSaleUnit); // 할인 판매단위

  if (receiptDiscount.DC_FLG_CD == 1) {
    // 1. 금액 할인 행사 일 시
    // discountPrice(baskets, posConfig, totSalesAmt, receiptEvntDcAmt);

    // 2. 아이템 별, 할인 금액 산정
    for (let i = 0; i < baskets.ITEMLIST.length; i++) {
      let item = baskets.ITEMLIST[i];

      let rate = item.SALES_AMT / totSalesAmt; // 총판매금액 대비 상품의 가격 비율
      let totDcAmt = rate * receiptEvntDcAmt; // 상품의 총 할인 금액
      let dcAmt = totDcAmt / item.SALES_QTY; // 상품 1개 당 할인 금액

      // 할인 금액을 판매단위에 맞게 보정
      if (discountAmountRoundType == 'round') {
        dcAmt = decimalHelper.roundInt(dcAmt, discountSaleUnit - 1);
      } else if (discountAmountRoundType == 'floor') {
        dcAmt = decimalHelper.floorInt(dcAmt, discountSaleUnit - 1);
      } else {
        dcAmt = decimalHelper.ceilInt(dcAmt, discountSaleUnit - 1);
      }

      item.SALES_UPRC = item.SALES_UPRC - dcAmt;
      item.DC_AMT = item.DC_AMT + dcAmt;
      item.SALES_AMT = item.SALES_UPRC * item.SALES_QTY;
      item.VAT_AMT = item.SALES_AMT / item.VAT_RATE;

      // 총 판매 금액 (할인 적용되지 않은)
      //baskets.HEADER.TOT_SALES_AMT += item.SALES_UPRC * item.SALES_QTY;
      baskets.HEADER.TOT_SALES_AMT += (item.SALES_UPRC + item.DC_AMT) * item.SALES_QTY;
      // 총 할인 금액
      baskets.HEADER.TOT_DC_AMT += item.DC_AMT * item.SALES_QTY;
      // 총 판매 수량
      baskets.HEADER.SALES_QTY += item.SALES_QTY;
      // 총 주문 수량 (옵션 상품 제외)
      baskets.HEADER.ORDER_QTY += item.SALES_QTY;
      // 총 판매 금액 (할인 적용된)
      baskets.HEADER.SALES_AMT += item.SALES_AMT;
      // 총 부가세액
      baskets.HEADER.VAT_AMT += item.VAT_AMT;
    }
  } else if (receiptDiscount.DC_FLG_CD == 2) {
    // 2. % 할인 행사 일 시
    //discountRate(baskets, posConfig, totSalesAmt, receiptEvntDcAmt);

    // 2. 아이템 별, 할인 금액 산정
    for (let i = 0; i < baskets.ITEMLIST.length; i++) {
      let item = baskets.ITEMLIST[i];
      let dcAmt = item.SALES_UPRC * (receiptEvntDcAmt / 100); // 상품 1개 당 할인 금액

      // 할인 금액을 판매단위에 맞게 보정
      if (discountAmountRoundType == 'round') {
        dcAmt = decimalHelper.roundInt(dcAmt, discountSaleUnit - 1);
      } else if (discountAmountRoundType == 'floor') {
        dcAmt = decimalHelper.floorInt(dcAmt, discountSaleUnit - 1);
      } else {
        dcAmt = decimalHelper.ceilInt(dcAmt, discountSaleUnit - 1);
      }

      item.SALES_UPRC = item.SALES_UPRC - dcAmt;
      item.DC_AMT = item.DC_AMT + dcAmt;
      item.SALES_AMT = item.SALES_UPRC * item.SALES_QTY;
      item.VAT_AMT = item.SALES_AMT / item.VAT_RATE;

      // 총 판매 금액 (할인 적용되지 않은)
      //baskets.HEADER.TOT_SALES_AMT += item.SALES_UPRC * item.SALES_QTY;
      baskets.HEADER.TOT_SALES_AMT += (item.SALES_UPRC + item.DC_AMT) * item.SALES_QTY;
      // 총 할인 금액
      baskets.HEADER.TOT_DC_AMT += item.DC_AMT * item.SALES_QTY;
      // 총 판매 수량
      baskets.HEADER.SALES_QTY += item.SALES_QTY;
      // 총 주문 수량 (옵션 상품 제외)
      baskets.HEADER.ORDER_QTY += item.SALES_QTY;
      // 총 판매 금액 (할인 적용된)
      baskets.HEADER.SALES_AMT += item.SALES_AMT;
      // 총 부가세액
      baskets.HEADER.VAT_AMT += item.VAT_AMT;
    }
  }

  // 멤버쉽 정보 취소 시, ORIGIN 정보 보관용
  baskets.HEADER.ORG_SALES_AMT = baskets.HEADER.SALES_AMT;
  baskets.HEADER.ORG_TOT_DC_AMT = baskets.HEADER.TOT_DC_AMT;
  baskets.HEADER.ORG_VAT_AMT = baskets.HEADER.VAT_AMT;
};

/**
 * 쿠폰 적용
 *
 * @param {*} baskets : 장바구니 상품 정보
 * @param {*} posConfig : Pos Config
 * @param {*} couponType : 쿠폰 타입
 * @returns
 */
exports.coupon = async (baskets, posConfig, couponInfo, posTransaction) => {
  const amountRoundType = posConfig.amountRoundType.toLowerCase(); // 금액 계산 방식 (반올림-round/절상-ceil/절하-floor)
  const saleUnit = Number(posConfig.saleUnit); // 판매단위

  let couponUprc = couponInfo.DISCOUNT_VALUE;

  if (couponInfo.TYPE === 'DISCOUNT' || couponInfo.TYPE === 'AMOUNT') {
    if (couponInfo.DISCOUNT_TYPE === 'FLAT_RATE') {
      couponUprc = couponInfo.DISCOUNT_VALUE;
    } else if (couponInfo.DISCOUNT_TYPE === 'FIXED_RATE') {
      couponUprc = (baskets.HEADER.SALES_AMT * couponInfo.DISCOUNT_VALUE) / 100;
      couponUprc = Math.min(couponUprc, couponInfo.MAX_DISCOUNT_AMOUNT);
    }
  }

  // 교환권 적용
  if (couponInfo.TYPE === 'EXCHANGE') {
    couponUprc = couponInfo.PLU_INFO.UnitPrice;
  }

  let vat = couponUprc * (posConfig.taxRate / 100);
  vat = Math.floor(vat);

  // 판매 단위에 따라 포인트 및 부가세 계산
  if (amountRoundType === 'ceil') {
    couponUprc = decimalHelper.ceilInt(couponUprc, saleUnit - 1);
    vat = decimalHelper.ceilInt(vat, saleUnit - 1);
  } else if (amountRoundType === 'floor') {
    couponUprc = decimalHelper.floorInt(couponUprc, saleUnit - 1);
    vat = decimalHelper.floorInt(vat, saleUnit - 1);
  } else {
    couponUprc = decimalHelper.roundInt(couponUprc, saleUnit - 1);
    vat = decimalHelper.roundInt(vat, saleUnit - 1);
  }

  // 쿠폰 가격이 지불할 금액과 같거나 이상일 시 처리
  if (couponUprc >= baskets.HEADER.SALES_AMT) {
    baskets.HEADER.TOT_DC_AMT = baskets.HEADER.SALES_AMT;
    baskets.HEADER.SALES_AMT = 0;
    baskets.HEADER.VAT_AMT = 0;
  } else {
    baskets.HEADER.SALES_AMT = baskets.HEADER.SALES_AMT - couponUprc;
    baskets.HEADER.TOT_DC_AMT = baskets.HEADER.TOT_DC_AMT + couponUprc;
    baskets.HEADER.VAT_AMT = baskets.HEADER.VAT_AMT - vat;
  }
};

/**
 * 멤버쉽 적용
 *
 * @param {*} baskets : 장바구니 상품 정보
 * @param {*} posConfig : Pos Config
 * @param {*} point : 멤버쉽 포인트
 * @returns
 */
exports.membership = async (baskets, posConfig, point) => {
  const amountRoundType = posConfig.amountRoundType.toLowerCase(); // 금액 계산 방식 (반올림-round/절상-ceil/절하-floor)
  const saleUnit = Number(posConfig.saleUnit); // 판매단위

  let vat = point * (posConfig.taxRate / 100);
  vat = Math.floor(vat);

  // 판매 단위에 따라 포인트 및 부가세 계산
  if (amountRoundType === 'ceil') {
    point = decimalHelper.ceilInt(point, saleUnit - 1);
    vat = decimalHelper.ceilInt(vat, saleUnit - 1);
  } else if (amountRoundType === 'floor') {
    point = decimalHelper.floorInt(point, saleUnit - 1);
    vat = decimalHelper.floorInt(vat, saleUnit - 1);
  } else {
    point = decimalHelper.roundInt(point, saleUnit - 1);
    vat = decimalHelper.roundInt(vat, saleUnit - 1);
  }

  // 총 판매 금액에서 멤버쉽 포인트 할인 적용
  baskets.HEADER.SALES_AMT = baskets.HEADER.SALES_AMT - point;
  if (baskets.HEADER.SALES_AMT < 0) baskets.HEADER.SALES_AMT = 0;

  // 지불한 금액에 포인트 합산
  baskets.HEADER.PAID_AMT = baskets.HEADER.PAID_AMT + point;

  // 총 부가세 계산
  baskets.HEADER.VAT_AMT = baskets.HEADER.VAT_AMT - vat;
};

/**
 * 멤버쉽, 쿠폰 취소
 *
 * @param {*} baskets : 장바구니 상품 정보
 * @returns
 */
exports.cancleMembership = async (baskets) => {
  baskets.HEADER.SALES_AMT = baskets.HEADER.ORG_SALES_AMT;
  baskets.HEADER.TOT_DC_AMT = baskets.HEADER.ORG_TOT_DC_AMT;
  baskets.HEADER.VAT_AMT = baskets.HEADER.ORG_VAT_AMT;
  baskets.HEADER.PAID_AMT = 0;
};
